import s from "./styles.module.sass";

const Banner = () => {
	return (
		<section className={`${s.banner} marginedSection`}>
			<div className={s.leftSide}>
				<h1>
					Объединяем людей
					<br />с помощью знаний
				</h1>
				<p className={s.description}>
					Наша миссия — сделать обучение <br />
					увлекательным и доступным для каждого
				</p>
			</div>
			<div className={s.image} />
		</section>
	);
};

export default Banner;
